import { Controller } from "@hotwired/stimulus"

// Marketing sections ease in once, when scrolled to. Only what starts below
// the fold is ever hidden, and only once this has connected: without
// JavaScript, or with reduced motion, every .www-rv is simply visible.
export default class extends Controller {
  connect() {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) return

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.remove("www-rv-wait")
        this.observer.unobserve(entry.target)
      })
    }, { rootMargin: "0px 0px -8% 0px" })

    this.element.querySelectorAll(".www-rv").forEach((el) => {
      if (el.getBoundingClientRect().top <= innerHeight * 0.92) return
      el.classList.add("www-rv-wait")
      this.observer.observe(el)
    })
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.querySelectorAll(".www-rv-wait").forEach((el) => el.classList.remove("www-rv-wait"))
  }
}
